import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, finalize, lastValueFrom, take } from 'rxjs';
import { CountryModel } from 'src/app/api/models/country.model';
import { PhonePrefixes } from 'src/app/api/models/phonePrefixes.model';
import { Price } from 'src/app/api/models/price.model';
import { ConsentService } from 'src/app/api/services/consent.service';
import { CountryService } from 'src/app/api/services/country.service';
import { MemberService } from 'src/app/api/services/member.service';
import { PriceService } from 'src/app/api/services/price.service';
import { AppResource } from 'src/app/app.resource';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { Civility, civiliteObject } from 'src/app/core/models/civility.model';
import { BackendContextSouscripteur } from 'src/app/core/models/context.model';
import { TypeHabitation } from 'src/app/core/models/form-state.model';
import { Info } from 'src/app/core/models/info.model';
import { Question } from 'src/app/core/models/question.model';
import { Step } from 'src/app/core/models/step.model';
import { Stepper } from 'src/app/core/models/stepper.model';
import { State } from 'src/app/core/state/core.state';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { CANAL_VENTE_C } from 'src/app/shared/constants/context.constants';
import { TOKEN } from 'src/app/shared/constants/localstorage.constants';
import { RATE_PATH, ROOT_PATH } from 'src/app/shared/constants/route.constants';
import {
  BIRTHDAY,
  BIRTHDAY_COUNTRY,
  BIRTHDAY_PLACE,
  BIRTHDAY_POSTALCODE,
  CIVILITY,
  CONFIRM_EMAIL,
  EMAIL,
  FIRST_NAME,
  LAST_NAME,
  NATIONALITY,
  PHONE,
  PHONE_GROUP,
  PHONE_PREFIX
} from 'src/app/shared/constants/subscriber-form.constants';
import { NAME_REGEX } from 'src/app/shared/constants/validators.constants';
import { getMetropoleBaseName } from 'src/app/shared/helpers/metropole-helper.service';
import { Commune } from 'src/app/shared/models/components/geocodejson.model';
import { PopUpInfoVM } from 'src/app/shared/models/components/popupinfoVm';
import { SubscriberCGVm } from 'src/app/shared/models/components/subscriberCGVm';
import { AdresseDataGouvService } from 'src/app/shared/services/adresse-data-gouv.service';
import { SubscriberStepService } from 'src/app/shared/services/subscriber-step.service';
import { ApiRequestBodyUtils } from 'src/app/shared/utils/apiRequestBodyUtils';
import { ApiResponseBodyUtils } from 'src/app/shared/utils/apiResponseBodyUtils';
import { DateUtils } from 'src/app/shared/utils/dateUtils';
import { MemberEmailValidator } from 'src/app/shared/validators/member-email.validator';
import { environment } from 'src/environments/environment';
import { String } from 'typescript-string-operations';
import * as fromAddress from '../../../core/state/address';
import * as fromContext from '../../../core/state/context';
import * as fromHousing from '../../../core/state/housing';
import * as fromInfo from '../../../core/state/info';
import * as fromSubscriberInsured from '../../../core/state/insured';
import * as fromOffer from '../../../core/state/offer-customization';
import * as fromPath from '../../../core/state/path';
import * as fromService from '../../../core/state/service';
import * as fromSubscriber from '../../../core/state/subscriber';
import * as fromTarification from '../../../core/state/tarification';
import { isPartner } from 'src/app/shared/utils/brandUtils';

@Component({
  selector: 'app-subscriber',
  templateUrl: './subscriber.component.html',
  styleUrls: ['./subscriber.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubscriberComponent extends BaseComponent implements OnInit {
  override step: Step = {
    step: this.resource.header.stepContact,
    stepNumber: 2,
    subStep: this.resource.header.subStepSubscriber,
    subStepNumber: 0
  };

  override question: Question = {
    libelle: this.resource.question.subscriber,
    popupInfo: undefined
  };

  override info: Info;
  maxDate: Date;
  minDate: Date;
  subscriberForm!: FormGroup;
  phoneGroup!: FormGroup;
  stateDataContextSubscriber: BackendContextSouscripteur | null | undefined;

  civilities: Civility[] = civiliteObject;
  selectedCivility: Civility | undefined;
  displayStudentStep: boolean = false;
  path!: PathType;
  pathType = PathType;
  subscriberCGVm!: SubscriberCGVm;
  subscriberInsured: SubscriberCGVm | undefined;
  showInsuredForm: boolean = false;
  estClient: boolean = false;
  phoneMember!: string | null;
  phonePrefixMember: PhonePrefixes[] | undefined;

  cities = new Array<Commune>();
  filteredCity = new Array<Commune>();

  isSignatoryFormFilled: boolean = false;
  needToFillFormOneMoreTime: boolean = false;

  countries = new Array<CountryModel>();
  filteredCountries = new Array<CountryModel>();

  placeHoldBirthday: string = this.resource.subscriber.superior18;

  context!: string;

  emailStep = new FormControl();
  emailStepConfirm = false;
  loginPopupClosable = true;

  memberLoginPopup: boolean = false;
  initAccountPopup: boolean = false;
  emailMember: string = '';

  birthdayPostalCodeNoResult: boolean = false;
  isStudentSubscription: boolean = false;
  isTheSameAsInsured: boolean = false;

  popupInfoFloor = new PopUpInfoVM([this.resource.infobulle.textPhoneConsent]);

  get civility() {
    return this.subscriberForm?.get(CIVILITY);
  }

  get firstName() {
    return this.subscriberForm?.get(FIRST_NAME);
  }

  get lastName() {
    return this.subscriberForm?.get(LAST_NAME);
  }

  get birthday() {
    return this.subscriberForm?.get(BIRTHDAY);
  }

  get nationality() {
    return this.subscriberForm?.get(NATIONALITY);
  }

  get birthdayCountry(): AbstractControl<CountryModel> | null {
    return this.subscriberForm?.get(BIRTHDAY_COUNTRY);
  }

  get birthdayPostalCode() {
    return this.subscriberForm?.get(BIRTHDAY_POSTALCODE);
  }

  get birthdayPlace() {
    return this.subscriberForm?.get(BIRTHDAY_PLACE);
  }

  get email() {
    return this.subscriberForm?.get(EMAIL);
  }

  get confirmEmail() {
    return this.subscriberForm?.get(CONFIRM_EMAIL);
  }

  get phone() {
    return this.subscriberForm?.get(PHONE_GROUP)?.get(PHONE);
  }

  get phonePrefix() {
    return this.subscriberForm?.get(PHONE_GROUP)?.get(PHONE_PREFIX);
  }

  get brand() {
    return environment.brand;
  }

  isLoading: boolean = false;

  informationBlock = new PopUpInfoVM([this.resource.subscriber.infoPhone]);
  constructor(
    private readonly router: Router,
    store: Store<State>,
    resources: AppResource,
    private readonly subscriberStepService: SubscriberStepService,
    private priceService: PriceService,
    private countryService: CountryService,
    private consentService: ConsentService,
    private memberService: MemberService,
    private adresseDataGouvService: AdresseDataGouvService,
    private memberEmailValidator: MemberEmailValidator
  ) {
    super(store, resources);

    let today = new Date();
    today = new Date(today.setFullYear(today.getFullYear() - 18));
    this.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 100));
    this.maxDate = new Date(today.setDate(today.getDate() - 1));

    this.info = {
      title: this.resource.infotop.beforeLastStep,
      secondTitle: '',
      subTitle: this.resource.infotop.beforeLastStepB,
      logo: this.resource.infotop.logoTime,
      isVisible: false
    };
  }

  canSearchCity: boolean = true;

  override async ngOnInit() {
    super.ngOnInit();

    await this.loadSubscriberState();

    this.initializeAgeLimits();

    this.subscriberCGVm = new SubscriberCGVm(
      String.format(
        this.resource.subscriber.text1CG,
        String.format('Assurance Habitation {0}', getMetropoleBaseName(this.path) ?? 'Confort')
      ),
      this.resource.subscriber.text2CG,
      this.resource.subscriber.text3CG,
      this.resource.subscriber.text3bisCG,
      this.resource.subscriber.text4CG,
      this.resource.subscriber.text5CG
    );

    this.updateResumeStepVisibility(true);
    await this.loadCountries();

    this.initEmailStep();

    await this.loadStateData();

    // Désactiver la modification du formulaire dans le cas d'un client (non prospect) si la valeur est connue
    if (this.estClient) {
      this.disableExistingContextDataFormControls(this.brand);
    }
  }

  private initEmailStep() {
    this.emailStep = new FormControl<string | null>('', {
      validators: [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
      ],
      asyncValidators: [this.memberEmailValidator.validate.bind(this.memberEmailValidator)],
      nonNullable: true,
      updateOn: 'change'
    });
  }

  async confirmEmailStep() {
    this.emailStepConfirm = true;
    const infoCopy = { ...this.info };
    infoCopy.isVisible = true;
    this.info = infoCopy;
    this.dispatchHeaderInfo();

    let stateContextData = await lastValueFrom(
      this.store.select(fromContext.selectContextData).pipe(take(1))
    );
    this.initForm();
    // Reset subscriber infos
    this.subscriberForm.reset();
    if (this.path !== PathType.HOUSING_ETUDIANTE) {
      this.store.dispatch(fromSubscriber.resetSubscriber());
    } else {
      const subPayload = await lastValueFrom(
        this.store.select(fromSubscriber.selectSubscriber).pipe(take(1))
      );
      this.emailStep.setValue(subPayload.subscriber?.Email);
    }
    this.memberService.emailExists(this.emailStep.value).subscribe(data => {
      if (stateContextData?.souscripteur?.nom) {
        this.initformFromContextData(stateContextData.souscripteur);
      } else if (data === false) {
        this.initFormNotMember();
      } else {
        if (stateContextData?.canalVente === CANAL_VENTE_C) {
          this.memberService.getByEmail(this.emailStep.value).subscribe({
            next: data => {
              this.initFormMember(data);
            }
          });
        } else {
          this.memberIsEnrolled(this.emailStep.value).subscribe(isEnrolled => {
            if (isEnrolled) {
              this.memberLoginPopup = true;
              this.emailMember = this.emailStep.value;
            } else {
              this.initAccountPopup = true;
            }
          });
        }
      }
    });
  }

  initformFromContextData(souscripteur: BackendContextSouscripteur) {
    this.initForm();
    let datePipe = new DatePipe('fr-FR');
    this.selectedCivility = this.civilities.find(obj => {
      return obj.id === souscripteur.civilite;
    });

    this.lastName?.setValue(souscripteur.nom);
    this.firstName?.setValue(souscripteur.prenom);
    this.civility?.setValue(this.selectedCivility);
    this.birthday?.setValue(datePipe.transform(souscripteur.dateNaissance, 'dd/MM/yyyy'));
    this.birthdayPlace?.setValue(souscripteur.villeNaissance);
    this.birthdayPostalCode?.setValue(souscripteur.codePostalNaissance);
    this.birthdayCountry?.setValue(
      this.countries.find(x => x.countryNameFr === souscripteur.paysNaissance)!
    );
    this.nationality?.setValue(
      this.brand === 'HM'
        ? this.countries.find(x => x.countryCode === souscripteur.nationalite)!
        : this.countries.find(x => x.countryNameFr === souscripteur.nationalite)!
    );
    this.email?.setValue(souscripteur.email);
    if (this.estClient && souscripteur.email) this.confirmEmail?.setValue(souscripteur.email);
    if (!this.subscriberForm.get(PHONE_GROUP) && this.phoneGroup) {
      this.subscriberForm.addControl(PHONE_GROUP, this.phoneGroup);
    }
    this.phone?.setValue(souscripteur.telephone);
    if (this.estClient) {
      this.subscriberForm.controls['consentValid'].clearValidators();
    }

    this.disableExistingContextDataFormControls(this.brand);
  }

  memberIsEnrolled(email: string): Observable<boolean> {
    return this.memberService.isEnrolled(email);
  }

  initFormMember(data: any) {
    let datePipe = new DatePipe('fr-FR');
    let birthCountry = this.countries.find(x => x.countryNameFr == data.birthCountry)!;
    let nationalityCountry = this.countries.find(x => x.countryNameFr == data.nationality)!;
    this.selectedCivility = this.civilities.find(obj => {
      return obj.value === data.civility || obj.id === data.civilityTypeId;
    });
    this.civility?.setValue(this.selectedCivility);
    this.lastName?.setValue(data.lastName);
    this.firstName?.setValue(data.firstName);
    this.birthday?.setValue(datePipe.transform(data.birthDate, 'dd/MM/yyyy'));
    this.birthdayCountry?.setValue(birthCountry);
    this.nationality?.setValue(nationalityCountry);
    this.birthdayPlace?.setValue(data.birthCity);
    this.birthdayPostalCode?.setValue(data.birthZipCode);
    this.email?.setValue(this.emailStep.value);
    this.phone?.reset();
    if (data.phoneNumber) {
      this.phone?.setValue(data.phoneNumber);
      this.phonePrefix?.setValue(this.phonePrefixMember?.find(x => x.prefix === data.phonePrefix));
    }
    this.updateFormControlsState();
  }

  initFormNotMember() {
    this.initForm();
    this.subscriberForm.addControl(PHONE_GROUP, this.phoneGroup);
    this.email?.setValue(this.emailStep.value);
    this.email?.disable();
  }

  updateFormControlsState(): void {
    const updateControlState = (control: AbstractControl | null, enable: boolean) => {
      if (control) {
        if (enable) {
          control.enable();
        } else {
          control.disable();
        }
      }
    };

    Object.keys(this.subscriberForm.controls).forEach(key => {
      const control = this.subscriberForm.get(key);
      if (key !== PHONE_GROUP) {
        const shouldEnable =
          control?.value === null || control?.value === '' || control?.value === undefined;
        updateControlState(control, shouldEnable);
      }
    });

    // CHECK if the birthdayCountry not is France, then birthdayPostalCode is disabled
    if (this.birthdayCountry && this.birthdayCountry?.value.countryNameFr !== 'France') {
      this.birthdayPostalCode?.disable();
      this.birthdayPostalCode?.clearValidators();

      this.birthdayPlace?.disable();
      this.birthdayPlace?.clearValidators();
    }

    this.subscriberForm.updateValueAndValidity();
  }

  async loadCountries() {
    this.countries = await lastValueFrom(this.countryService.GetCountries().pipe(take(1)));

    // Sort countries by country code with France as first item of the list
    this.countries.sort((c1, c2) => {
      const franceCode = 'FR';
      if (c1.countryCode === franceCode) return -1;
      else if (c2.countryCode === franceCode) return 1;
      else return c1.countryCode.localeCompare(c2.countryCode); // Usual string comparison
    });

    this.filteredCountries = this.countries;
  }

  private initForm() {
    this.subscriberForm = new FormGroup(
      {
        civility: new FormControl<Civility[] | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        firstName: new FormControl<string | null>(null, {
          validators: [
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern(NAME_REGEX)
          ],
          nonNullable: true
        }),
        lastName: new FormControl<string | null>(null, {
          validators: [
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern(NAME_REGEX)
          ],
          nonNullable: true
        }),
        birthday: new FormControl<string | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        nationality: new FormControl<string | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        birthdayCountry: new FormControl<CountryModel | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        birthdayPostalCode: new FormControl<string | null>('', {
          validators: [Validators.required, Validators.pattern('^[0-9]{5}$')],
          nonNullable: true
        }),
        birthdayPlace: new FormControl<string | null>('', {
          validators: [Validators.required],
          nonNullable: true
        }),
        email: new FormControl<string | null>('', {
          validators: [
            Validators.required,
            Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
          ],
          asyncValidators: [this.memberEmailValidator.validate.bind(this.memberEmailValidator)],
          nonNullable: true
        }),
        consentValid: new FormControl<boolean | undefined>(undefined, {
          validators: this.brand === 'TODO' ? [Validators.required] : [], //(TODO Notif A faire pour HM)
          nonNullable: false
        })
      },
      {
        updateOn: 'change'
      }
    );
    this.birthdayCountry!.valueChanges.subscribe(country => {
      if (country) {
        if (country.countryNameFr === 'France') {
          this.birthdayPostalCode?.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]{5}$')
          ]);
          this.birthdayPostalCode?.updateValueAndValidity();
          this.canSearchCity = true;
          this.birthdayPostalCode?.enable();
        } else {
          this.birthdayPostalCode?.clearValidators();
          this.birthdayPostalCode?.updateValueAndValidity();
          // disable city search if country is not France
          this.canSearchCity = false;
          this.birthdayPostalCode?.disable();
        }
      }
    });

    this.birthdayPostalCode!.valueChanges.subscribe(postalCode => {
      // La recherche de ville par code postal ne s'applique que pour une naissance en France
      if (this.birthdayCountry?.value?.countryNameFr !== 'France') {
        return;
      }
      if (postalCode?.length == 5) {
        this.adresseDataGouvService.getCityByPostalCode(postalCode).subscribe({
          next: (res: Commune[]) => {
            if (res) {
              this.cities = res;
              if (res.length >= 1) {
                this.birthdayPlace?.setValue(res[0].nomCommune);
                this.birthdayPostalCodeNoResult = false;
              }
            }
          },
          error: () => {
            this.cities = [];
            this.birthdayPostalCodeNoResult = true;
            this.birthdayPlace?.setValue('');
          }
        });
      } else {
        this.birthdayPlace?.setValue('');
      }
    });
  }

  public validCheckboxes($event: any) {
    if (!$event.voies.some((c: any) => c.isCheck === undefined)) {
      this.subscriberForm.controls['consentValid'].setValue(true);
    }
  }

  disableExistingContextDataFormControls(brand: string) {
    if (this.stateDataContextSubscriber?.civilite)
      this.subscriberForm.controls['civility'].disable();
    if (this.stateDataContextSubscriber?.prenom)
      this.subscriberForm.controls['firstName'].disable();
    if (this.stateDataContextSubscriber?.nom) this.subscriberForm.controls['lastName'].disable();
    if (
      this.stateDataContextSubscriber?.paysNaissance &&
      this.countries.find(
        c =>
          c[this.brand === 'HM' ? 'countryCode' : 'countryNameFr'] ===
          this.stateDataContextSubscriber?.paysNaissance
      ) &&
      !isPartner(brand)
    ) {
      this.subscriberForm.controls['birthdayCountry'].disable();
    }
    if (
      this.stateDataContextSubscriber?.nationalite &&
      this.countries.find(
        c =>
          c[this.brand === 'HM' ? 'countryCode' : 'countryNameFr'] ===
          this.stateDataContextSubscriber?.nationalite
      ) &&
      !isPartner(brand)
    ) {
      this.subscriberForm.controls['nationalite'].disable();
    }
    if (this.stateDataContextSubscriber?.dateNaissance)
      this.subscriberForm.controls['birthday'].disable();
    if (
      this.stateDataContextSubscriber?.villeNaissance &&
      this.stateDataContextSubscriber?.codePostalNaissance &&
      !isPartner(brand)
    ) {
      this.subscriberForm.controls['birthdayPlace'].disable();
      this.subscriberForm.controls['birthdayPostalCode'].disable();
    }
    if (this.stateDataContextSubscriber?.email) {
      this.subscriberForm.controls['email'].disable();
    }
  }

  private async loadStateData() {
    this.store.dispatch(
      fromSubscriber.changeValidationStatus({
        isValid: false
      })
    );
    // Change header info for student path
    if (this.path === PathType.HOUSING_ETUDIANTE && this.displayStudentStep) {
      const payload = {
        subStep: this.resource.header.subStepNumberMonths,
        step: this.resource.header.subStepPolicyDuration,
        stepNumber: 1,
        subStepNumber: 1
      } as Partial<Step>;
      this.store.dispatch(fromInfo.updateStep({ payload }));
    }

    let contextId = await lastValueFrom(
      this.store.select(fromContext.selectContextId).pipe(take(1))
    );
    this.context = contextId!;

    let stateContextData = await lastValueFrom(
      this.store.select(fromContext.selectContextData).pipe(take(1))
    );

    this.stateDataContextSubscriber = stateContextData?.souscripteur;

    // If email is present in the context, auto-fill and validate the email step
    if (this.stateDataContextSubscriber?.email) {
      this.loginPopupClosable = false;
      this.emailStep.setValue(this.stateDataContextSubscriber.email);
      this.confirmEmailStep();
    }
  }

  filterCity($event: any) {
    let query = $event.query;
    if (query != null && this.canSearchCity) {
      let trimmedQuery = query
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('fr-FR');
      this.filteredCity = this.cities.filter(item => {
        return (item.nomCommune ?? '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLocaleLowerCase('fr-FR')
          .includes(trimmedQuery);
      });
    } else {
      this.filteredCity = [];
    }
  }

  async filterCountries($event: any) {
    let query = $event.query;
    if (query != null) {
      let trimmedQuery = query
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('fr-FR');
      this.filteredCountries = this.countries.filter(item => {
        return item.countryNameFr
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLocaleLowerCase('fr-FR')
          .includes(trimmedQuery);
      });
    } else {
      this.filteredCountries = this.countries;
    }
  }

  addPhoneControls(phoneControls: FormGroup) {
    this.initForm();
    this.phoneGroup = phoneControls;
    this.subscriberForm.addControl(PHONE_GROUP, phoneControls);
    this.subscriberForm.updateValueAndValidity();
  }

  getPhonePrefixes(event: PhonePrefixes[]) {
    this.phonePrefixMember = event;
  }

  async confirmStep() {
    this.isLoading = true;
    const subscriberIsTheSameAsInsured = await lastValueFrom(
      this.store.select(fromSubscriber.selectSubscriber).pipe(take(1))
    );

    if (
      this.path === PathType.HOUSING_ETUDIANTE &&
      !subscriberIsTheSameAsInsured.isTheSameAsInsured
    ) {
      this.store.dispatch(
        fromSubscriberInsured.patchInsured({
          payload: {
            Civilite: this.civility?.value.value,
            Nom: this.lastName?.value,
            Prenom: this.firstName?.value,
            Email: this.email?.value,
            Indicatif: this.phonePrefix?.value ? this.phonePrefix?.value.prefix : '',
            Telephone: this.phone?.value,
            DateNaissance: DateUtils.DayMonthYearToIso(this.birthday?.value) ?? undefined,
            CodePostalNaissance: this.birthdayPostalCode?.value,
            LieuNaissance: this.birthdayPlace?.value?.nomCommune ?? this.birthdayPlace?.value,
            PaysNaissance: this.birthdayCountry?.value.countryNameFr,
            Nationalite: this.nationality?.value.countryNameFr
          }
        })
      );
    } else {
      this.store.dispatch(
        fromSubscriber.patchSubscriber({
          payload: {
            Civilite: this.civility?.value.value,
            Nom: this.lastName?.value,
            Prenom: this.firstName?.value,
            Email: this.email?.value,
            Indicatif: this.phonePrefix?.value ? this.phonePrefix?.value.prefix : '',
            Telephone: this.phone?.value,
            DateNaissance: DateUtils.DayMonthYearToIso(this.birthday?.value) ?? undefined,
            CodePostalNaissance: this.birthdayPostalCode?.value,
            LieuNaissance: this.birthdayPlace?.value?.nomCommune ?? this.birthdayPlace?.value,
            PaysNaissance: this.birthdayCountry?.value.countryNameFr,
            Nationalite: this.nationality?.value.countryNameFr
          }
        })
      );
    }

    if (this.path === PathType.HOUSING_ETUDIANTE) {
      // check type habitation and change it if needed
      const stateHousing = await lastValueFrom(
        this.store.select(fromHousing.selectHousing).pipe(take(1))
      );
      const typeHabitation = stateHousing.SaisieHabitation.TypeHabitation as TypeHabitation;
      if (typeHabitation === TypeHabitation.Chambre) {
        this.store.dispatch(
          fromHousing.patchHousingType({
            payload: {
              TypeHabitation: TypeHabitation.Chambre
            }
          })
        );
      }
    }
    if (this.path !== PathType.HOUSING_ETUDIANTE) {
      await this.subscriberStepService.confirmStep(
        this.resource,
        this.brand,
        this.civility?.value.value!,
        this.lastName?.value,
        this.firstName?.value,
        this.email?.value,
        this.phonePrefix?.value.prefix,
        this.phone?.value,
        DateUtils.DayMonthYearToIso(this.birthday?.value)!,
        this.birthdayPlace?.value?.nomCommune ?? this.birthdayPlace?.value,
        this.birthdayCountry?.value.countryNameFr!,
        this.path,
        () => (this.isLoading = false)
      );
    }

    // Retrieve context
    const context = await lastValueFrom(
      this.store.select(fromContext.selectContextId).pipe(take(1))
    );

    // Retrieve product
    const product = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));

    // Retrieve address
    const stateAddress = await lastValueFrom(
      this.store.select(fromAddress.selectAddress).pipe(take(1))
    );

    // Retrieve housing informations
    const stateHousing = await lastValueFrom(
      this.store.select(fromHousing.selectHousing).pipe(take(1))
    );

    // Retrieve selected formule informations
    const stateOffer = await lastValueFrom(
      this.store.select(fromOffer.selectOfferCustomization).pipe(take(1))
    );

    const stateService = await lastValueFrom(
      this.store.select(fromService.selectService).pipe(take(1))
    );

    // Retrieve service informations
    const privateLessorName =
      stateService.saisieChoixServices.EnvoiAttestationBailleur?.BailleurPrive?.NomBailleur ?? null;
    const socialLessorName =
      stateService.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur ??
      null;

    let saisieInsured = null;
    const isHousingEtudiante = this.path === PathType.HOUSING_ETUDIANTE;
    if (isHousingEtudiante) {
      saisieInsured = await lastValueFrom(
        this.store.select(fromSubscriberInsured.selectInsured).pipe(take(1))
      );
    }
    const coverageDurationInMonths = saisieInsured === null ? null : saisieInsured.duration;

    const lessorName =
      privateLessorName ?? socialLessorName ?? stateAddress.adresseEsh?.NomBailleur ?? null;

    const body = ApiRequestBodyUtils.GenerateTarifCreateRequestBody(
      context!,
      product,
      this.brand,
      stateAddress.adresseType,
      stateAddress.addresseSelection,
      stateAddress.addresseManuelle,
      stateAddress.adresseEsh,
      stateHousing.SaisieHabitation,
      {
        ...stateOffer.SaisieFormule,
        FormuleSelectionnee: undefined // Recalculate all formules
      },
      stateOffer.FormuleRecommandee!,
      coverageDurationInMonths,
      this.email?.value,
      lessorName
    );

    let consent = (
      await lastValueFrom(this.store.select(fromSubscriber.selectSubscriber).pipe(take(1)))
    ).subscriber?.Consentement;

    this.priceService
      .GetProductPrices(body)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res: Price) => {
          this.store.dispatch(
            fromSubscriber.changeValidationStatus({
              isValid: true
            })
          );

          // Store returned informations about formules in the state
          const tarifInfos = ApiResponseBodyUtils.ExtractTarifResponseBody(res, this.path);
          this.store.dispatch(
            fromTarification.patchTarification({
              payload: tarifInfos
            })
          );

          // Send consent informations for HM case (TODO Notif A faire pour HM)
          if (consent && this.brand === 'TODO') {
            const bodyConsent = ApiRequestBodyUtils.GeneratePostConsentRequestBody(
              this.context,
              consent.IdLibelle,
              consent.VoiesConsentement
            );
            this.consentService.PostConsentement(bodyConsent).subscribe({
              error: (error: any) => {
                console.error("Une erreur s'est produite :", error);
              },
              complete: () => {
                this.router.navigate([`${ROOT_PATH}${RATE_PATH}`]);
              }
            });
          } else {
            this.router.navigate([`${ROOT_PATH}${RATE_PATH}`]);
          }
        },
        error: (error: any) => {
          console.error("Une erreur s'est produite :", error);
        }
      });

    await this.updateStepper();
  }

  async updateStepper() {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    let tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;

    let title = tmpStepper.devis.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.offer
    );

    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.subscriber
    );

    if (subtitleS) subtitleS.isValid = true;

    let subtitleN = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.rate
    );
  }

  ToLowerCase(event: any) {
    let value = event.target.value;
    event.target.value = value.toLowerCase();
  }

  ToCapitalize(event: any) {
    let value = event.target.value;
    if (value[0] != undefined) event.target.value = value[0].toUpperCase() + value.slice(1);
  }

  goToLink(url: string) {
    window.open(url, '_blank');
  }

  closeDialogLogin() {
    this.memberLoginPopup = false;
    this.emailStepConfirm = false;
  }

  closeInitPopup() {
    this.initAccountPopup = false;
    this.emailStepConfirm = true;
    this.memberLoginPopup = true;
  }

  closeAuthPopup() {
    this.memberLoginPopup = false;
    this.emailStepConfirm = false;
  }

  closeValidLoginAndMfa(event: boolean) {
    let token = JSON.parse(localStorage.getItem(TOKEN) || '""');
    if (token && event === true) {
      this.subscriberForm.addControl(PHONE_GROUP, this.phoneGroup);
      this.memberService.getUserInfoAuth().subscribe(data => {
        this.initFormMember(data);
        // If email is present in the context (the subscriber exists), confirm the step
        if (this.stateDataContextSubscriber?.email) this.confirmStep();
      });
    }
  }

  async nextStep() {
    this.showInsuredForm = true;
    console.log('checklist', this.subscriberForm.valid, this.isSignatoryFormFilled);
    if (!this.isSignatoryFormFilled) {
      this.store.dispatch(
        fromSubscriber.patchSubscriber({
          payload: {
            Civilite: this.civility?.value.value,
            Nom: this.lastName?.value,
            Prenom: this.firstName?.value,
            Email: this.email?.value,
            Indicatif: this.phonePrefix?.value ? this.phonePrefix?.value.prefix : '',
            Telephone: this.phone?.value,
            CodePostalNaissance: this.birthdayPostalCode?.value,
            DateNaissance: DateUtils.DayMonthYearToIso(this.birthday?.value) ?? undefined,
            LieuNaissance: this.birthdayPlace?.value?.nomCommune ?? this.birthdayPlace?.value,
            PaysNaissance: this.birthdayCountry?.value.countryNameFr,
            Nationalite: this.nationality?.value.countryNameFr
          }
        })
      );
      this.isSignatoryFormFilled = true;
      const stockPhone = this.phonePrefix?.value;
      this.subscriberForm.reset();

      this.phonePrefix!.setValue(stockPhone);

      const storeStudent = await lastValueFrom(
        this.store.select(fromSubscriberInsured.selectInsured).pipe(take(1))
      );
      this.email?.setValue(storeStudent.insured?.Email);
      this.subscriberForm.enable();
      // same behavior as for the parent
      this.email?.disable();
      this.needToFillFormOneMoreTime = false;
      if (this.path === PathType.HOUSING_ETUDIANTE) {
        const today = new Date();
        this.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 29));
        this.maxDate = new Date(today.setFullYear(today.getFullYear() - 16));
        this.placeHoldBirthday = this.resource.subscriber.etudiantAge;
      }

      this.question = {
        libelle: this.resource.question.subscriberInsured
      };
      this.dispatchHeaderQuestion();
    } else {
      this.store.dispatch(
        fromSubscriberInsured.patchInsured({
          payload: {
            Civilite: this.civility?.value.value,
            Nom: this.lastName?.value,
            Prenom: this.firstName?.value,
            Email: this.email?.value,
            Indicatif: this.phonePrefix?.value ? this.phonePrefix?.value.prefix : '',
            Telephone: this.phone?.value,
            DateNaissance: DateUtils.DayMonthYearToIso(this.birthday?.value) ?? undefined,
            LieuNaissance: this.birthdayPlace?.value?.nomCommune ?? this.birthdayPlace?.value,
            PaysNaissance: this.birthdayCountry?.value.countryNameFr,
            Nationalite: this.nationality?.value.countryNameFr,
            CodePostalNaissance: this.birthdayPostalCode?.value
          }
        })
      );
    }
  }

  async loadSubscriberState() {
    this.path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));
    if (this.path === PathType.HOUSING_ETUDIANTE) {
      this.displayStudentStep = true;
    }
    this.isStudentSubscription = this.path === PathType.HOUSING_ETUDIANTE;
    const subscriberInfo = await lastValueFrom(
      this.store.select(fromSubscriber.selectSubscriber).pipe(take(1))
    );
    this.isTheSameAsInsured = subscriberInfo.isTheSameAsInsured ?? false;
  }

  async initFormHE() {
    await this.loadSubscriberState();

    this.displayStudentStep = false;
    this.isSignatoryFormFilled = this.isTheSameAsInsured!;
    this.initializeAgeLimits();

    this.emailStepConfirm = true;
    this.confirmEmailStep();

    this.question = {
      libelle: this.resource.question.subscriberSignatory
    };
    this.dispatchHeaderQuestion();

    const subscriberIsTheSameAsInsured = await lastValueFrom(
      this.store.select(fromSubscriber.selectSubscriber).pipe(take(1))
    );

    if (
      subscriberIsTheSameAsInsured.isTheSameAsInsured !== undefined &&
      subscriberIsTheSameAsInsured.isTheSameAsInsured === false
    ) {
      this.needToFillFormOneMoreTime = true;
    }
  }

  private initializeAgeLimits() {
    const initializeForIssured =
      this.isStudentSubscription && !this.isTheSameAsInsured && this.isSignatoryFormFilled;

    if (initializeForIssured) {
      // 16 to 29 years old
      const today = new Date();
      this.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 29));
      this.maxDate = new Date(today.setFullYear(today.getFullYear() - 16));
    } else if (this.isStudentSubscription && this.isTheSameAsInsured) {
      // 18 to 29 years old (case subscriber = insured)
      const today = new Date();
      this.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 29));
      this.maxDate = new Date(today.setFullYear(today.getFullYear() - 18) - 1);
    } else {
      // from 18 years old
      let today = new Date();
      today = new Date(today.setFullYear(today.getFullYear() - 18));
      this.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 100));
      this.maxDate = new Date(today.setDate(today.getDate() - 1));
    }
  }
}
